import axios from './request'

export function fetchHouseNew(ids, aIds, defaultBetweenDays = 1, pagesize = 0, promotion, needNoRepositoty, houseCardType, checkInDate, checkOutDate, onlyCanBooking, noBooking, cityId) {
  return axios.post('/bnbapp-node-h5/h5/promotion/search/searchhousebyhouseidlist', {
    houseIdList: ids,
    activityIds: aIds,
    defaultBetweenDays: +defaultBetweenDays,
    pageSize: +pagesize,
    promotion: promotion,
    needUnactive: false,
    needNoRepositoty,
    houseCardType,
    checkInDate,
    checkOutDate,
    onlyCanBooking,
    noNeedPrice: noBooking,
    cityId: cityId
  })
}

export function fetchHouse(ids, aIds, defaultBetweenDays = 1, pagesize = 0, promotion, needNoRepositoty, houseCardType, checkInDate, checkOutDate, onlyCanBooking, noBooking) {
  return axios.post('/feapi/bingo/h5/promotion/search/searchhousebyhouseidlist', {
    houseIdList: ids,
    activityIds: aIds,
    defaultBetweenDays: +defaultBetweenDays,
    pageSize: +pagesize,
    promotion: promotion,
    needUnactive: false,
    needNoRepositoty,
    houseCardType,
    checkInDate,
    checkOutDate,
    onlyCanBooking,
    noNeedPrice: noBooking
  })
}

// export function fetchHouseV3(ids, aIds, defaultBetweenDays = 1, pagesize = 0, promotion, needNoRepositoty, houseCardType, checkInDate, checkOutDate, cmsId, noBooking) {
//   return axios.post('/feapi/bingo/h5/promotion/search/searchhousebyhouseidlist/v3', {
//     houseIdList: ids,
//     activityIds: aIds,
//     needUnactive: false,
//     noNeedPrice: noBooking,
//     pageSize: +pagesize,
//     defaultBetweenDays: +defaultBetweenDays,
//     promotion: promotion,
//     needNoRepositoty,
//     houseCardType,
//     checkInDate,
//     checkOutDate,
//     cmsId
//   })
// }

/**
 * 通过商户id搜索房屋
 * @param {number} cityId 城市id
 * @param {Array} landlordIds 商户id
 * @param {number} defaultBetweenDays 居住间夜
 * @param {number} pagesize 展示数量
 * @param {number} pageIndex 页码
 * @param {Boolean} needNoRepositoty 库存售完是否仍展示房屋
 */
// eslint-disable-next-line
export function fetchBrandHouse({ cityId, landlordIds, defaultBetweenDays = 1, pagesize = 0, pageIndex, needNoRepositoty }) {
  return axios.post('/feapi/bingo/h5/promotion/search/searchbylandlords', arguments[0])
}

/**
 * 筛选项过滤房屋接口
 * @param {number} cityId 城市id
 * @param {Array} topShowUnitIds 房屋列表
 * @param {Array} alwaysTopShowUnitIds 始终展示最上方的房屋（这版没有）
 * @param {Array} filters 筛选项条件
 * @param {String} checkInDate 入住日期
 * @param {String} checkOutDate 离店日期
 * @param {number} pagesize 展示数量
 * @param {number} pageIndex 页码
 * @param {number} geoPositionId 地标/商圈
 */
export function fetchHouseWithFilter({ alwaysTopShowUnitIds = [], topShowUnitIds = [], pageIndex = 1, checkInDate, checkOutDate, pageSize, geoPositionId, filters = [], cityId, noResultRecommend }) {
  return axios.post('/feapi/bingo/h5/promotion/search/searchhousewithfilter', arguments[0])
}

/**
 * 搜索系统
 * @param {number} cityId 城市id
 */
export function searchHouse() {
  return axios.post('/bnbapp-node-h5/h5/search/v2/searchhouseForCMS/bnb', arguments[0])
}

/**
 * 查询收藏
 */
export function fetchFavirote(ids) {
  return axios.post('/feapi/bingo/h5/favorite/checkfavorite', {
    houseIdList: ids
  })
}

/**
 * 收藏/取消收藏
 */
export function doFavirote(id, like) {
  let url = ''
  if (like) {
    url = '/feapi/bingo/h5/favorite/deletefavorite'
  } else {
    url = '/feapi/bingo/h5/favorite/addfavorite'
  }
  return axios.post(url, {
    houseId: id
  })
}
